enum CustomerType {
    Company = "Company",
    Person = "Person"
}

export default CustomerType;